// Who is signed in, and the two ways out of the app to the pas-auth sign-in. Screens and the app bar call these
// rather than the API layer.

import { getClient } from '../api/client'
import { signIn, signOut as authSignOut } from '../api/auth'
import { clearSignedOut, markSignedOut } from '../api/signedOut'
import { clearAppSession } from './draft'

/** The caller's display name (for the avatar); null when it cannot be read. */
export async function loadUserName(): Promise<string | null> {
  try {
    return (await getClient().me()).name
  } catch {
    return null
  }
}

/**
 * Clears this app's session keys (a kept order draft is PHI; the next person at a shared
 * workstation must not inherit it), marks the tab signed out (so the page /logout returns to
 * shows the signed-out screen instead of signing the same person straight back in), then the
 * pas-auth logout. Resolves only by navigating away (the local harness has no sign-in: it logs,
 * and the mark is taken back).
 */
export async function signOut(storage?: Storage): Promise<void> {
  let s: Storage | null = null
  try {
    s = storage ?? window.sessionStorage
    clearAppSession(s)
    markSignedOut(s)
  } catch {
    // no sessionStorage: nothing of ours is kept
  }
  try {
    await authSignOut()
  } catch (e) {
    if (s) clearSignedOut(s)
    console.warn('Sign-out is unavailable here', e)
  }
}

/**
 * The sign-in redirect, for a session that expired mid-use or from the signed-out screen. The
 * person asked to sign in, so the signed-out mark goes first. Resolves only by navigating away.
 */
export async function signInAgain(): Promise<void> {
  try {
    clearSignedOut(window.sessionStorage)
  } catch {
    // no sessionStorage: no mark either
  }
  try {
    await signIn()
  } catch (e) {
    console.warn('Sign-in is unavailable here', e)
  }
}
